import { render, staticRenderFns } from "./PaymentMadeToInvoice.vue?vue&type=template&id=2f18a28a&"
import script from "./PaymentMadeToInvoice.vue?vue&type=script&lang=js&"
export * from "./PaymentMadeToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports